<script setup lang="ts">
    import { useConfigStore } from '@/store/config.store';
    import { EAppStep } from '@/typescript/enums/EAppStep';
    import CanvasContainer from '@/components/CanvasContainer.vue';
    import MobileFabricCanvas from '@/components/MobileFabricCanvas.vue';
    import { useProductHas3d } from '@/composables/useProductHas3d';
    import { computed } from 'vue';
    import { storeToRefs } from 'pinia';

    const { currentStep } = storeToRefs(useConfigStore());
    const { productHas3DModel } = useProductHas3d();
    const showPreview = computed(() => currentStep.value === EAppStep.PREVIEW);
</script>
<template>
    <div class="relative h-dvh w-full">
        <MobileFabricCanvas v-if="!showPreview" />
        <CanvasContainer
            v-if="productHas3DModel && showPreview"
            class="h-dvh w-full"
        />
    </div>
</template>
